import { readAll, toPromise } from '../idb';
export const LEGACY_TABLE_CHECK = 'check';
export const LEGACY_TABLE_KEYS = 'keys';
export const LEGACY_TABLE_CONNECTIONS = 'connections';
export const LEGACY_TABLE_HISTORY = 'history';
export const LEGACY_TABLE_CACHE = 'cache';
export const LEGACY_TABLES = [
    LEGACY_TABLE_CHECK,
    LEGACY_TABLE_KEYS,
    LEGACY_TABLE_CONNECTIONS,
    LEGACY_TABLE_HISTORY,
    LEGACY_TABLE_CACHE,
];
const PASSWORD_ORACLES = [LEGACY_TABLE_CHECK, LEGACY_TABLE_KEYS, LEGACY_TABLE_CONNECTIONS];
async function decryptRow(cryptography, password, row) {
    const key = await cryptography.legacyDeriveKey(password, Uint8Array.from(row.salt));
    return await cryptography.legacyDecrypt(key, Uint8Array.from(row.iv), Uint8Array.from(row.encryptedData));
}
export async function countLegacyRows(db, cryptography, tables) {
    let total = 0;
    for (const table of tables) {
        const name = await cryptography.legacyHashString(table);
        if (!db.objectStoreNames.contains(name))
            continue;
        const transaction = db.transaction([name], 'readonly');
        total += await toPromise(transaction.objectStore(name).count());
    }
    return total;
}
export async function readLegacyTable(context, table) {
    const storeName = await context.cryptography.legacyHashString(table);
    const rows = await readAll(context.db, storeName);
    const decoded = [];
    for (const row of rows) {
        decoded.push(await decryptRow(context.cryptography, context.password, row));
    }
    return decoded;
}
export async function existingLegacyStores(db, cryptography) {
    const names = [];
    for (const table of LEGACY_TABLES) {
        const name = await cryptography.legacyHashString(table);
        if (db.objectStoreNames.contains(name))
            names.push(name);
    }
    return names;
}
export async function hasLegacyVault(db, cryptography) {
    for (const table of PASSWORD_ORACLES) {
        const name = await cryptography.legacyHashString(table);
        if (!db.objectStoreNames.contains(name))
            continue;
        const transaction = db.transaction([name], 'readonly');
        if ((await toPromise(transaction.objectStore(name).count())) > 0)
            return true;
    }
    return false;
}
export async function verifyLegacyPassword(db, cryptography, password) {
    for (const table of PASSWORD_ORACLES) {
        const name = await cryptography.legacyHashString(table);
        const rows = await readAll(db, name);
        if (rows.length === 0)
            continue;
        try {
            await decryptRow(cryptography, password, rows[0]);
            return true;
        }
        catch {
            return false;
        }
    }
    return false;
}
